<template>
  <div class="menu disp-scroll"
  :class="{'custom-menu': !isMenuMiniSize, 'custom-menu-min': isMenuMiniSize}">
    <!-- モーダル画面 -->
    <div style="display: flex;">
      <!-- アラートダイアログ -->
      <ModalAlertDialog
        :isAlertDialogOpen="isAlertDialogOpen"
        :alertData="alertData"
        @alertResult="alertResult"
      />
    </div>
    <b-modal :active.sync="isReleaseMarkdown" @close="isReleaseMarkdown=false">
      <ReleaseMarkdown />
    </b-modal>
    <b-modal :active.sync="isViewMarkdown" @close="isViewMarkdown=false">
      <ViewMarkdown v-bind:sendnowID="sendID()"
        :sendvalue="sendValue()"
        :sendnowDate="sendDate()"
        :sendreadDate="sendMessage()"
        :sendtitle="sendTitle()"
        @contentsMessage="contentsMethod"/>
    </b-modal>
    <ModalRequestHelp />
    <RoboCreate
      :isCardModalActive="isShowRoboCreate"
      @cancel="showRoboCreate"
      :PCTRLLOG="CTRLLOG"
    />
    <RoboCreateRequest
      :isCardModalActive="isShowRoboCreateRequest"
      @cancel="showRoboCreateRequest"
      :PCTRLLOG="CTRLLOG"
    />
    <b-modal width="680px" :active.sync="isShowBilling">
      <div class="card" style="border-radius: 5px;">
        <header class="card-header">
          <p class="card-header-title">
            プランにつきまして
          </p>
        </header>
        <div class="card-content">
          <p>
            <b-message type="is-info" has-icon>
              ご利用ありがとうございます。
              現在無料のトライアル期間を過ぎた状態でご使用になっております。
              現状のままご使用になられますとアカウントが停止になる場合もございます。
              下記よりプランの選択画面へ移動していただき、早急にプランをお選びいただけますようお願い致します。
            </b-message>
          </p>
        </div>
        <footer class="card-footer">
          <a class="card-footer-item" @click="isShowBilling=false">閉じる</a>
          <a class="card-footer-item" @click="isShowBilling=false; $router.push('/client/setting/billing?view=plan')">プラン選択画面へ</a>
        </footer>
      </div>
    </b-modal>
    <b-modal width="680px" :active.sync="isShowBillingNoFeature">
      <div class="card" style="border-radius: 5px;">
        <header class="card-header">
          <p class="card-header-title">
            こちらの機能をご使用になられたい場合に
          </p>
        </header>
        <div class="card-content">
          <p>
            <b-message type="is-info" has-icon>
              スタンダードもしくはライトプランで使用が可能です。
              ご利用されたい場合は下記プラン選択画面にてご変更いただけますよう
              お願い致します。
            </b-message>
          </p>
        </div>
        <footer class="card-footer">
          <a class="card-footer-item" @click="isShowBillingNoFeature=false">閉じる</a>
          <a class="card-footer-item" @click="isShowBillingNoFeature=false; $router.push('/client/setting/billing?view=plan')">プラン選択画面へ</a>
        </footer>
      </div>
    </b-modal>
    <ul class="menu-list">
      <div v-if="!isMenuMiniSize" style="height: 51px;">
        <img src="@/assets/logo.svg" style="margin-left: -6px; height: 51px; width: auto; object-fit: cover; max-height: none;">
      </div>
      <div v-else style="height: 51px;">
        <img src="@/assets/whitemonster60.png" style="margin-left: 10px; margin-top: 10px; margin-bottom: 11px; height: 20px; width: auto; object-fit: cover; max-height: none;">
      </div>
      <li class="list-info" id="list-info" @mouseover="mouseoverUserInfo" @mouseleave="mouseleaveUserInfo">
        <router-link to="/client/setting/personal" :class="{'click-menu': $route.path === '/'}" class="hover-menu">
          <img class="account-img" style="max-height: none;" :src="profileImage">
          <p v-if="!isMenuMiniSize" style="font-size: 13px; color: #ffffff;">{{user.username}}</p>
        </router-link>
        <ul :class="{'dropdown-list': !isMenuMiniSize, 'dropdown-list-mini': isMenuMiniSize}" :style="dropdownListHeight" v-if="ListUserInfoFlg">
          <li @click="releaseMarkdownModal()" v-if="user.isAgent && !menuActive">
            <p class="link">
              通知発信
            </p>
          </li>
          <li @click="viewMarkdownModal()" v-if="!menuActive">
            <p class="link">
              通知
            </p>
          </li>
          <li @click="setRHModal()">
            <p class="link">
              お問合わせ
            </p>
          </li>
          <li @click="logout()">
            <p class="link">
              ログアウト
            </p>
          </li>
          <li v-if="user.isAgent && isMenuMiniSize">
            <!-- スーパーユーザーの場合 -->
            <div style="height: 55px; display: flex; align-items: center; position: relative;">
              <select v-model="currentCompany"
                      class="select is-small"
                      style="left: 5px; max-width: 140px;"
                      placeholder="会社名を選択">
                <option v-for="(c, index) in filteredCompanyList"
                  :value="c.id"
                  :key="index">
                  {{ c.name }}
                </option>
              </select>
              <button @click="updateUserCompany(currentCompany)"
                class="button is-primary"
                style="font-size: 12px;">
                移動
              </button>
            </div>
          </li>
        </ul>
      </li>
      <li class="list-direct" @mouseover="mouseleaveReset" v-if="!isMenuMiniSize">
        <!-- スーパーユーザーの場合 -->
        <div style="height: 30px;" v-if="user.isAgent">
          <select v-model="currentCompany"
                  class="select is-small"
                  style="left: 5px; max-width: 140px; border-top-right-radius: 0; border-bottom-right-radius: 0;"
                  placeholder="会社名を選択">
            <option v-for="(c, index) in filteredCompanyList"
              :value="c.id"
              :key="index">
              {{ c.name }}
            </option>
          </select>
          <button @click="updateUserCompany(currentCompany)"
            class="button is-primary"
            style="font-size: 12px; border-radius: 0; align-items: center;">
            移動
          </button>
        </div>
        <!-- 一般ユーザーの場合 -->
        <div style="height: 30px;" v-else>
          <p style="padding: 8px; font-size: 13px; color: #ffffff;">{{user.companyName}}</p>
        </div>
      </li>
      <li v-else>
        <div style="height: 30px;"></div>
      </li>
      <li @click="isMenuMinimumSize()" @mouseover="mouseleaveReset">
        <p style="cursor: hand; cursor:pointer; margin-top: 12px; margin-bottom: 4px; padding: 8px; font-size: 13px;">
          <span v-if="!isMenuMiniSize" class="mdi mdi-format-horizontal-align-left mdi-24px mdi-light" style="margin-right: 8px;"></span>
          <span v-else class="mdi mdi-format-horizontal-align-right mdi-24px mdi-light" style="margin-right: 0px;"></span>
        </p>
      </li>
      <!--  ロボ社員メニュー  -->
      <li class="list-direct" @mouseover="mouseleaveReset">
        <p v-if="!isMenuMiniSize" style="margin-top: 12px; margin-bottom: 4px; padding: 8px; font-size: 13px;"><span style="color: white; font-weight: 600;">ロボ社員メニュー</span></p>
        <p v-else style="margin-top: 12px; margin-bottom: 4px; padding: 8px; font-size: 13px;"><span style="color: white; font-weight: 600;">&nbsp;</span></p>
      </li>
      <li class="list-robo-employment" id="list-robo-employment" @mouseover="mouseoverListRoboCreate"  @mouseleave="mouseleaveListRoboCreate">
        <router-link to="/client/robo_employment" :class="{'click-menu': $route.path === '/client/robo_employment'}" class="hover-menu">
          <span class="mdi mdi-factory mdi-24px mdi-light" style="margin-right: 8px;"></span>
          <span v-if="!isMenuMiniSize">ロボ新規作成</span>
        </router-link>
        <ul :class="{'dropdown-list': !isMenuMiniSize, 'dropdown-list-mini': isMenuMiniSize}" :style="dropdownListHeight" v-if="ListRoboCreateFlg">
          <li>
            <router-link to="/client/robo_employment">
              ロボ社員を選ぶ
            </router-link>
          </li>
          <li @click="showRoboCreateRequest(true)">
            <!-- 直接ダイアログを開くので、router-linkはダミー -->
            <p class="link">
              サポートに相談
            </p>
          </li>
          <li @click="showRoboCreate(true)">
            <!-- 直接ダイアログを開くので、router-linkはダミー -->
            <p class="link">
              作成
            </p>
          </li>
        </ul>
      </li>
      <li class="list-robo" id="list-robo" @mouseover="mouseoverListRobo"  @mouseleave="mouseleaveListRobo">
        <router-link to="/client/chatbot?view=sitemap" :class="{'click-menu': $route.path === '/client/chatbot?view=sitemap'}" class="hover-menu">
          <span class="mdi mdi-robot mdi-24px mdi-light" style="margin-right: 8px;"></span>
          <span v-if="!isMenuMiniSize">ロボ社員</span>
        </router-link>
        <ul :class="{'dropdown-list': !isMenuMiniSize, 'dropdown-list-mini': isMenuMiniSize}" :style="dropdownListHeight" v-if="ListRoboFlg">
          <li>
            <router-link to="/client/chatbot?view=sitemap">
              ロボ出勤
            </router-link>
          </li>
          <li>
            <router-link to="/client/robo_list">
              在籍ロボ一覧
            </router-link>
          </li>
          <li @click="moveToScenarioTop()" v-if="chatbots.length > 0 && !isCBLoading">
            <p class="link">
              ロボ編集
            </p>
          </li>
          <li v-if="isCBLoading">
            <p class="link">
              ロボ編集
            </p>
          </li>
        </ul>
      </li>
      <li class="list-direct" @mouseover="mouseleaveReset">
        <a :class="{'click-menu': $route.path === '/client/directtalk', 'startup': user.billing === 0}" class="hover-menu" @click="isShowBillingNoFeature = true" v-if="user.billing === 0">
          <span class="mdi mdi-comment-processing-outline mdi-24px mdi-light" style="margin-right: 8px;"></span>
          <span v-if="!isMenuMiniSize">ロボ会話履歴</span>
        </a>
        <router-link to="/client/directtalk" :class="{'click-menu': $route.path === '/client/directtalk'}" class="hover-menu" v-else>
          <span class="mdi mdi-comment-processing-outline mdi-24px mdi-light" style="margin-right: 8px;"></span>
          <span v-if="!isMenuMiniSize">ロボ会話履歴</span>
        </router-link>
      </li>
      <li @mouseover="mouseleaveReset">
        <router-link to="/client/setting/app_icon" :class="{'click-menu': $route.path === '/client/setting/app_icon'}" class="hover-menu">
          <span class="mdi mdi-home mdi-24px mdi-light" style="margin-right: 8px;"></span>
          <span v-if="!isMenuMiniSize">ホームページ設定</span>
        </router-link>
      </li>
      <!--  採用関連メニュー  -->
      <li class="list-direct" @mouseover="mouseleaveReset">
        <p v-if="!isMenuMiniSize" style="margin-top: 12px; margin-bottom: 4px; padding: 8px; font-size: 13px;"><span style="color: white; font-weight: 600;">採用関連メニュー</span></p>
        <p v-else style="margin-top: 12px; margin-bottom: 4px; padding: 8px; font-size: 13px;"><span style="color: white; font-weight: 600;">&nbsp;</span></p>
      </li>
      <li>
        <div v-if="!isButtonDisabled">
        <a :class="{'click-menu': $route.path.indexOf('/client/manage') !== -1, 'startup': user.billing === 0 || user.billing === 3}" class="hover-menu" @click="isShowBillingNoFeature = true" v-if="user.billing === 0 || user.billing === 3">
          <span class="mdi mdi-account-card-details mdi-24px mdi-light" style="margin-right: 8px;"></span>
          <span v-if="!isMenuMiniSize">応募者管理</span>
        </a>
        <router-link to="/client/manage" :class="{'click-menu': $route.path.indexOf('/client/manage') !== -1, 'startup': user.billing === 0}" class="hover-menu" v-else>
          <span class="mdi mdi-account-card-details mdi-24px mdi-light" style="margin-right: 8px;"></span>
          <span v-if="!isMenuMiniSize">応募者管理</span>
        </router-link>
        </div>
        <div class="hover-menu startup no-viewing-permission-applicant" v-else>
          <span class="mdi mdi-account-card-details mdi-24px mdi-light" style="margin-right: 8px;"></span>
          <span v-if="!isMenuMiniSize">応募者管理</span>
        </div>
      </li>
      <li @mouseover="mouseleaveReset">
        <div v-if="!isButtonDisabled">
        <a :class="{'click-menu': $route.path === '/client/employment/list', 'startup': user.billing === 0 || user.billing === 3}" class="hover-menu" @click="isShowBillingNoFeature = true" v-if="user.billing === 0 || user.billing === 3">
          <span class="mdi mdi-book-multiple-plus mdi-24px mdi-light" style="margin-right: 8px;"></span>
          <span v-if="!isMenuMiniSize">求人公開(ジョブシェア)</span>
        </a>
        <router-link to="/client/employment/list?pages=1&recruit=true" :class="{'click-menu': $route.path === '/client/employment/list', 'startup': user.billing === 0}" class="hover-menu" v-else>
          <span class="mdi mdi-book-multiple-plus mdi-24px mdi-light" style="margin-right: 8px;"></span>
          <span v-if="!isMenuMiniSize">求人公開(ジョブシェア)</span>
        </router-link>
        </div>
        <div class="hover-menu startup no-viewing-permission-applicant" v-else>
          <span class="mdi mdi-book-multiple-plus mdi-24px mdi-light" style="margin-right: 8px;"></span>
          <span v-if="!isMenuMiniSize">求人公開(ジョブシェア)</span>
        </div>
      </li>
      <li class="list-direct" @mouseover="mouseleaveReset">
        <div v-if="!isButtonDisabled">
        <a :class="{'click-menu': $route.path === '/client/directtalk/scout', 'startup': user.billing === 0 || user.billing === 3}" class="hover-menu" @click="isShowBillingNoFeature = true" v-if="user.billing === 0 || user.billing === 3">
          <span class="mdi mdi-send mdi-24px mdi-light" style="margin-right: 8px;"></span>
          <span v-if="!isMenuMiniSize">訪問者自動スカウト</span>
        </a>
        <router-link to="/client/directtalk/scout" :class="{'click-menu': $route.path === '/client/directtalk/scout', 'startup': user.billing === 0}" class="hover-menu" v-else>
          <span class="mdi mdi-send mdi-24px mdi-light" style="margin-right: 8px;"></span>
          <span v-if="!isMenuMiniSize">訪問者自動スカウト</span>
        </router-link>
        </div>
        <div class="hover-menu startup no-viewing-permission-applicant" v-else>
          <span class="mdi mdi-send mdi-24px mdi-light" style="margin-right: 8px;"></span>
          <span v-if="!isMenuMiniSize">訪問者自動スカウト</span>
        </div>
      </li>
      <li>
        <div v-if="!isButtonDisabled">
        <li class="list-setting" id="list-video-interview" @mouseover="mouseoverVideoInteview"  @mouseleave="mouseleaveVideoInteview">
          <a :class="{'click-menu': $route.path === '/client/recordview', 'startup': user.billing === 0 || user.billing === 3}" class="hover-menu" @click="isShowBillingNoFeature = true" v-if="user.billing === 0 || user.billing === 3">
            <span class="mdi mdi-movie mdi-24px mdi-light" style="margin-right: 8px;"></span>
            <span v-if="!isMenuMiniSize">録画面接</span>
          </a>
          <router-link to="/client/recordview" :class="{'click-menu': $route.path === '/client/recordview', 'startup': user.billing === 0}" class="hover-menu" v-else>
            <span class="mdi mdi-movie mdi-24px mdi-light" style="margin-right: 8px;"></span>
            <span v-if="!isMenuMiniSize">録画面接</span>
          </router-link>
        </li>
        </div>
        <div class="hover-menu startup no-viewing-permission-applicant" v-else>
          <span class="mdi mdi-movie mdi-24px mdi-light" style="margin-right: 8px;"></span>
          <span v-if="!isMenuMiniSize">録画面接</span>
        </div>
      </li>
      <li @mouseover="mouseleaveReset">
        <router-link to="/client/setting/common" :class="{'click-menu': $route.path === '/client/setting/common'}" class="hover-menu">
          <span class="mdi mdi-contact-mail mdi-24px mdi-light" style="margin-right: 8px;"></span>
          <span v-if="!isMenuMiniSize">採用関連設定</span>
        </router-link>
      </li>
      <!--  共通メニュー  -->
      <li class="list-direct" @mouseover="mouseleaveReset">
        <p v-if="!isMenuMiniSize" style="margin-top: 12px; margin-bottom: 4px; padding: 8px; font-size: 13px;"><span style="color: white; font-weight: 600;">共通メニュー</span></p>
        <p v-else style="margin-top: 12px; margin-bottom: 4px; padding: 8px; font-size: 13px;"><span style="color: white; font-weight: 600;">&nbsp;</span></p>
      </li>
      <li @mouseover="mouseleaveReset">
        <router-link to="/client/calendar" :class="{'click-menu': $route.path === '/client/calendar'}" class="hover-menu">
          <span class="mdi mdi-calendar-today mdi-24px mdi-light" style="margin-right: 8px;"></span>
          <span v-if="!isMenuMiniSize">予定調整・カレンダー</span>
        </router-link>
      </li>
      <li>
        <div v-if="!isButtonDisabled">
        <li class="list-setting" id="list-video-interview" @mouseover="mouseoverVideoInteview"  @mouseleave="mouseleaveVideoInteview">
          <a :class="{'click-menu': $route.path === '/client/videoview', 'startup': user.billing === 0 || user.billing === 3}" class="hover-menu" @click="isShowBillingNoFeature = true" v-if="user.billing === 0 || user.billing === 3">
            <span class="mdi mdi-message-video mdi-24px mdi-light" style="margin-right: 8px;"></span>
            <span v-if="!isMenuMiniSize">ウェブ会議</span>
          </a>
          <router-link to="/client/videoview" :class="{'click-menu': $route.path === '/client/videoview', 'startup': user.billing === 0}" class="hover-menu" v-else>
            <span class="mdi mdi-message-video mdi-24px mdi-light" style="margin-right: 8px;"></span>
            <span v-if="!isMenuMiniSize">ウェブ会議</span>
          </router-link>
        </li>
        </div>
        <div class="hover-menu startup no-viewing-permission-applicant" v-else>
          <span class="mdi mdi-message-video mdi-24px mdi-light" style="margin-right: 8px;"></span>
          <span v-if="!isMenuMiniSize">ウェブ会議</span>
        </div>
      </li>
      <li @mouseover="mouseleaveReset">
        <div v-if="!isButtonDisabled">
        <a :class="{'click-menu': $route.path === '/client/mediapool', 'startup': user.billing === 0 || user.billing === 3}" class="hover-menu" @click="isShowBillingNoFeature = true" v-if="user.billing === 0 || user.billing === 3">
          <span class="mdi mdi-database mdi-24px mdi-light" style="margin-right: 8px;"></span>
          <span v-if="!isMenuMiniSize">社内メディア倉庫</span>
        </a>
        <router-link to="/client/mediapool" :class="{'click-menu': $route.path === '/client/mediapool', 'startup': user.billing === 0}" class="hover-menu" v-else>
          <span class="mdi mdi-database mdi-24px mdi-light" style="margin-right: 8px;"></span>
          <span v-if="!isMenuMiniSize">社内メディア倉庫</span>
        </router-link>
        </div>
        <div class="hover-menu startup no-viewing-permission-applicant" v-else>
          <span class="mdi mdi-database mdi-24px mdi-light" style="margin-right: 8px;"></span>
          <span v-if="!isMenuMiniSize">社内メディア会議</span>
        </div>
      </li>
      <li class="list-setting" id="list-setting" @mouseover="mouseoverSetting"  @mouseleave="mouseleaveSetting">
        <router-link to="/client/setting/personal" :class="{'click-menu': $route.path.indexOf('/client/setting/') !== -1 && $route.path !== '/client/setting/common' && $route.path !== '/client/setting/app_icon'}" class="hover-menu">
          <span class="mdi mdi-settings mdi-24px mdi-light" style="margin-right: 8px;"></span>
          <span v-if="!isMenuMiniSize">設定</span>
        </router-link>
        <ul :class="{'dropdown-list': !isMenuMiniSize, 'dropdown-list-mini': isMenuMiniSize}" :style="dropdownListHeight" v-if="ListSettingFlg">
          <li v-if="user.billing === 3">
            <router-link to="/client/setting/billing" :class="{'click-submenu': $route.path === '/client/setting/billing'}">
              請求
            </router-link>
          </li>
          <li v-if="user.billing === 0">
            <router-link to="/client/setting/billing?view=plan" :class="{'click-submenu': $route.path === '/client/setting/billing'}">
              プランを選択
            </router-link>
          </li>
          <li>
            <router-link to="/client/setting/personal" :class="{'click-submenu': $route.path === '/client/setting/personal'}">
              個人設定
            </router-link>
          </li>
          <li>
            <router-link to="/client/setting/other_api" :class="{'click-submenu': $route.path === '/client/setting/other_api'}">
              外部連携
            </router-link>
          </li>
          <!-- ユーザー一覧は管理者権限のユーザーのみ表示 -->
          <li v-if="user.permission === 0">
            <router-link to="/client/setting/user_list" :class="{'click-submenu': $route.path === '/client/setting/user_list'}">
              ユーザー一覧
            </router-link>
          </li>
          <li>
            <router-link to="/client/setting/company" :class="{'click-submenu': $route.path === '/client/setting/company'}">
              会社情報
            </router-link>
          </li>
        </ul>
      </li>
      <li class="list-operation" id="list-operation" @mouseover="mouseoverOperation"  @mouseleave="mouseleaveOperation" v-if="user.isAgent">
        <router-link to="/client/operation/controllog" :class="{'click-menu': $route.path.indexOf('/client/operation/') !== -1}" class="hover-menu">
          <span class="mdi mdi-account-supervisor mdi-24px mdi-light" style="margin-right: 8px;"></span>
          <span v-if="!isMenuMiniSize">運用</span>
        </router-link>
        <ul :class="{'dropdown-list': !isMenuMiniSize, 'dropdown-list-mini': isMenuMiniSize}" :style="dropdownListHeight" v-if="ListOperationFlg">
          <li>
            <router-link to="/client/operation/controllog" :class="{'click-submenu': $route.path === '/client/operation/controllog'}">
              操作履歴
            </router-link>
          </li>
          <!-- <li>
            <router-link to="/client/operation/recruitment_media" :class="{'click-submenu': $route.path === '/client/operation/recruitment_media'}">
              媒体情報
            </router-link>
          </li> -->
        </ul>
      </li>
      <!--  β版メニューメニュー  -->
      <li class="list-direct" @mouseover="mouseleaveReset">
        <p v-if="!isMenuMiniSize" style="margin-top: 12px; margin-bottom: 4px; padding: 8px; font-size: 13px;"><span style="color: white; font-weight: 600;">β版メニュー</span></p>
        <p v-else style="margin-top: 12px; margin-bottom: 4px; padding: 8px; font-size: 13px;"><span style="color: white; font-weight: 600;">&nbsp;</span></p>
      </li>
      <li @mouseover="mouseleaveReset">
        <router-link to="/client/calendar/task" :class="{'click-menu': $route.path === '/client/calendar/task'}" class="hover-menu">
          <span class="mdi mdi-calendar-clock mdi-24px mdi-light" style="margin-right: 8px;"></span>
          <span v-if="!isMenuMiniSize">タスク予定リスト</span>
        </router-link>
      </li>
      <li @mouseover="mouseleaveReset">
        <a :class="{'click-menu': $route.path === '/client/virtualoffice', 'startup': user.billing === 0}" class="hover-menu" @click="isShowBillingNoFeature = true" v-if="user.billing === 0">
          <span class="mdi mdi-home mdi-24px mdi-office-building mdi-light" style="margin-right: 8px;"></span>
          <span v-if="!isMenuMiniSize">エンゲージメント<br>オフィス</span>
          <span v-else>&nbsp;<br>&nbsp;</span>
        </a>
        <router-link to="/client/virtualoffice" :class="{'click-menu': $route.path === '/client/virtualoffice', 'startup': user.billing === 0}" class="hover-menu" v-else>
          <span class="mdi mdi-home mdi-24px mdi-office-building mdi-light" style="margin-right: 8px;"></span>
          <span v-if="!isMenuMiniSize">エンゲージメント<br>オフィス</span>
          <span v-else>&nbsp;<br>&nbsp;</span>
        </router-link>
      </li>
      <li @mouseover="mouseleaveReset">
        <div v-if="!isButtonDisabled">
        <a :class="{'click-menu': $route.path === '/client/story', 'startup': user.billing === 0 || user.billing === 3}" class="hover-menu" @click="isShowBillingNoFeature = true" v-if="user.billing === 0 || user.billing === 3">
          <span class="mdi mdi-contacts mdi-24px mdi-light" style="margin-right: 8px;"></span>
          <span v-if="!isMenuMiniSize">求人ノベル</span>
        </a>
        <router-link to="/client/story" :class="{'click-menu': $route.path === '/client/story', 'startup': user.billing === 0}" class="hover-menu" v-else>
          <span class="mdi mdi-contacts mdi-24px mdi-light" style="margin-right: 8px;"></span>
          <span v-if="!isMenuMiniSize">求人ノベル</span>
        </router-link>
        </div>
        <div class="hover-menu startup no-viewing-permission-applicant" v-else>
          <span class="mdi mdi-contacts mdi-24px mdi-light" style="margin-right: 8px;"></span>
          <span v-if="!isMenuMiniSize">求人ノベル</span>
        </div>
      </li>
      <li @mouseover="mouseleaveReset">
        <router-link to="/client/performance" :class="{'click-menu': $route.path === '/client/performance'}" class="hover-menu">
          <span class="mdi mdi-chart-histogram mdi-24px mdi-light" style="margin-right: 8px;"></span>
          <span v-if="!isMenuMiniSize" style="color: white;">ロボパフォーマンス画面</span>
        </router-link>
      </li>

      <!-- β版お試し -->
      <li class="list-report" id="list-report" @mouseover="mouseoverReport"  @mouseleave="mouseleaveReport">
        <router-link to="/client/report" :class="{'click-menu': $route.path === '/client/report'}" class="hover-menu">
          <span class="mdi mdi-message-video mdi-24px mdi-light" style="margin-right: 8px;"></span>
          <span v-if="!isMenuMiniSize">解析</span>
        </router-link>
        <ul :class="{'dropdown-list': !isMenuMiniSize, 'dropdown-list-mini': isMenuMiniSize}" :style="dropdownListHeight" v-if="reportFlg && user.billing !== 0">
          <li>
            <router-link to="/client/report" :class="{'click-submenu': $route.path === '/client/report'}">
              応募者解析レポート
            </router-link>
          </li>
          <!--ここは、無料メディアを入れられたら。
          <li>
            <router-link to="/client/xxx" :class="{'click-submenu': $route.path === '/client/setting/billing'}">
              未定（無料素材）
            </router-link>
          </li>
          -->
        </ul>
      </li>
      <!-- 少し隙間を空ける -->
      <li class="list-direct">
        <p v-if="!isMenuMiniSize" style="margin-top: 12px; margin-bottom: 4px; padding: 8px; font-size: 13px;"><span style="color: white; font-weight: 600;">&nbsp;</span></p>
        <p v-else style="margin-top: 12px; margin-bottom: 4px; padding: 8px; font-size: 13px;"><span style="color: white; font-weight: 600;">&nbsp;</span></p>
      </li>
      <li @mouseover="mouseleaveReset">
        <a class="hover-menu" @click="logout()">
          <span class="mdi mdi-logout mdi-24px mdi-light" style="margin-right: 8px;"></span>
          <span v-if="!isMenuMiniSize">ログアウト</span>
        </a>
      </li>
      <!-- 最後のメニューが見えにくくなることがあるので隙間を作る -->
      <li class="list-direct">
        <p v-if="!isMenuMiniSize" style="margin-top: 12px; margin-bottom: 4px; padding: 8px; font-size: 13px;"><span style="color: white; font-weight: 600;">&nbsp;</span></p>
        <p v-else style="margin-top: 12px; margin-bottom: 4px; padding: 8px; font-size: 13px;"><span style="color: white; font-weight: 600;">&nbsp;</span></p>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import session from '@/api/session'
import RoboCreate        from '@/components2/Robo/modal/RoboCreate'
import RoboCreateRequest from '@/components2/Robo/modal/RoboCreateRequest'
import controlLogMixin   from '@/mixins/controlLogMixin'
import ModalRequestHelp from '@/components/ui/ModalRequestHelp'
import ReleaseMarkdown from '../Release/ReleaseMarkdown'
import ViewMarkdown from '../Release/ViewMarkdown'
import Push from 'push.js'
import Tooltip from '@/components/atoms/tooltips/Tooltip'
import ModalAlertDialog from '@/components/organisms/common/ModalAlertDialog'
import {
  isRoboEditPermission
} from '@/functions/checkPermission'
import {
  /** アラートダイアログ用定義 */
  ALERT_DEF,
  /** アラートダイアログ用データ作成 */
  createAlertData
} from '@/functions/common/alertFunc'
export default {
  name: 'ClientMainMenu',
  componentName: 'ClientMainMenu',
  components: {
    ModalRequestHelp,
    ReleaseMarkdown,
    ViewMarkdown,
    Tooltip,
    ModalAlertDialog,
    RoboCreate,
    RoboCreateRequest,
  },
  mixins: [
    controlLogMixin
  ],
  props: {
    height: {
      type: String,
      default: '0px'
    }
  },
  data () {
    return {
      ListRoboCreateFlg: false,
      ListRoboFlg: false,
      ListSettingFlg: false,
      ListOperationFlg: false,
      ListDirectFlg: false,
      ListVideoInteviewFlg: false,
      isDebug: false,
      isShowBillingNoFeature: false,
      isShowBilling: false,
      isShowRoboCreate: false,
      isShowRoboCreateRequest: false,
      ListUserInfoFlg: false,
      menuActive: false,
      isChangedCompanyID: false,
      selectCompanyID: '',
      isReleaseMarkdown: false,
      isViewMarkdown: false,
      storageData: {},
      localData: [],
      releaseData: [],
      isMessage: false,
      messageData: {},
      activeVisitor: [],
      isVisitorInit: false,
      isDeniedCheck: false,
      start: Date.now(),
      executed: false,
      currentCompany: '',
      isAlertDialogOpen: false,
      alertData: {},
      reportFlg: false,
    }
  },
  computed: {
    ...mapState('virtualOffice', ['isVOConnectList']),
    ...mapState('sitemap', ['isFirstLoad', 'firstLoadCount']),
    ...mapState('directtalk', ['chatData', 'isConnectList','roomcount', 'roomlist', 'sortFlg', 'filterFlg']),
    ...mapState('chatbot', ['chatbots', 'isCBLoading']),
    ...mapState('auth', ['user', 'isModalRequestHelp', 'companyList']),
    ...mapState("tools",["releaseContents", "draftTexts", "releaseTexts"]),
    ...mapState("setting",["isMenuMiniSize"]),
    filteredCompanyList() {
      // キャンセル状態でない会社のみをフィルタリングし、会社名の五十音順で並び替える
      return this.companyList 
        ? this.companyList
            .filter(company => !company.is_cancel)
            .sort((a, b) => a.name.localeCompare(b.name, 'ja'))
        : [];
    },
    profileImage: function () {
      return this.user.profileIcon
    },
    plan () {
      if (this.user.billing === 0) return '無料プラン'
      else if (this.user.billing === 1) return 'ライトプラン'
      else if (this.user.billing === 2) return 'スタンダードプラン'
      else if (this.user.billing === 3) return '従量課金プラン'
      else return '有料プラン'
    },
    dropdownListHeight () {
      let el = undefined
      if (this.ListRoboCreateFlg) el = document.getElementById('list-robo-employment')
      else if (this.ListRoboFlg) el = document.getElementById('list-robo')
      else if (this.ListSettingFlg) el = document.getElementById('list-setting')
      else if (this.ListOperationFlg) el = document.getElementById('list-operation')
      else if (this.ListVideoInteviewFlg) el = document.getElementById('list-video-interview')
      else if (this.ListUserInfoFlg) el = document.getElementById('list-info')
      else if (this.reportFlg) el = document.getElementById('list-report')
      else return 'top: 0px;'
      return 'top: ' + el.getBoundingClientRect().top + 'px;';
    },
    isButtonDisabled () {
      return !this.user.isSeekerDisplayEnable
    }
  },
  // TODO: ローカライズ始まるまでは一旦切り替えないで日本語固定で
  mounted () {
    window.addEventListener('focus', this.focusIn)
    this.currentCompany = this.user.companyID
    this.$store.dispatch("tools/getText")
    this.localData = []
    this.storageData = JSON.parse(localStorage.getItem('IS_RELEASE_READ') || null)
    if (this.storageData == null) {
      this.storageData = {}
    }
    for (var i = 0; i < Object.keys(this.storageData).length; i++) {
      this.localData.push(this.storageData[i])
    }
    setTimeout(() => {this.handleClick_changeLanguage('ja')}, 2000)
  },
  watch: {
    releaseTexts () {
      this.releaseData = []
      for (var i = 0; i < this.releaseTexts.length; i++)
        this.releaseData.push(this.releaseTexts[i].contents_id + "/" + this.getSort(this.releaseTexts[i].updated_at))
      var newMessage = []
      newMessage = this.releaseData.filter(i => this.localData.indexOf(i) == -1)
      if (newMessage.length == 0) {
        this.messageFlag = false
      } else {
        this.messageFlag = true
      }
      this.isMessage = this.releaseTexts.map(v => v.is_read).includes(true)
    },
    roomcount () {
      let interval = Date.now() - this.start
      if (!this.sortFlg && !this.filterFlg) {
        if (interval > 10000) {
          this.executed = false
          this.getScoutSeeker()
        } else {
          if (!this.executed) {
            setTimeout(this.getScoutSeeker, 10000)
          }
          this.executed = true
        }
      }
      // 現在の訪問者数
      if (this.user.isNoticeNewVisitor) {
        // 起動時の訪問者情報取得
        if (!this.isVisitorInit) {
          // 起動時初回は現状の情報を通知処理前に取得しておく
          this.activeVisitor = this.roomlist.active
          this.isVisitorInit = true
        }

        // 通知設定チェック
        if (Push.Permission.get() === Push.Permission.DENIED && !this.isDeniedCheck) {
          // 通知の拒否設定がされていた場合、初回だけメッセージを表示する
          alert('訪問者通知の設定\nHRモンスターからの通知が拒否されています。\nブラウザの設定から通知を許可してください。')
          this.isDeniedCheck = true
          return
        } else if (Push.Permission.get() === Push.Permission.DENIED && this.isDeniedCheck) {
          // 通知拒否チェック済みの場合は何もしないで抜ける
          return
        } else if (Push.Permission.get() !== Push.Permission.GRANTED) {
          // この時点で通知未承認の場合、承認要求を行う
          Push.Permission.request()
        }

        // プッシュ通知
        if (Push.Permission.get() === Push.Permission.GRANTED) {
          // 通知承認済みなら新しい訪問者が来たかチェックする
          let isNewVisitor = false
          for (const room of this.roomlist.active) {
            let isVisiting = false
            for (const visitor of this.activeVisitor) {
              if (room.name === visitor.name) {
                // 現在訪問中の人
                isVisiting = true
                break
              }
            }
            if (!isVisiting) {
              // 新しく来た訪問者
              isNewVisitor = true
              // 1人でも新規の訪問者がいたら通知するので抜ける
              break
            }
          }
          // 現状の訪問者情報を退避
          this.activeVisitor = this.roomlist.active

          // プッシュ通知で表示
          if (isNewVisitor) {
            Push.create('HRモンスターからのお知らせ', {
              body: '新しい訪問者がいらっしゃいました！',
              icon: require('../../assets/lp/logo.png'),
              timeout: 5000,
              onClick: function () {
                window.focus()
                this.close()
              }
            })
          }
        }
      }
    },
    isModalRequestHelp () {
      this.allClose()
    },
    isConnectList () {
      if (!this.isConnectList) {
        setTimeout(() => {
          const uri = process.env.WS_ENDPOINT + 'list/' + this.user.companyID + '/' + this.user.email
          this.$store.dispatch('directtalk/connectList', uri)
        }, 5000)
      }
    },
    isVOConnectList () {
      if (!this.isVOConnectList) {
        setTimeout(() => {
          const uriVO = process.env.WS_ENDPOINT + 'vo/user_list/' + this.user.companyID + '/' + this.user.userHash
          this.$store.dispatch('virtualOffice/connectVirtualOfficeSV', uriVO)
        }, 5000)
      }
    },
  },
  updated () {
    const uriVO = process.env.WS_ENDPOINT + 'vo/user_list/' + this.user.companyID + '/' + this.user.userHash
    this.$store.dispatch('virtualOffice/connectVirtualOfficeSV', uriVO)
    const con = {'is_connect': true}
    this.$store.dispatch('auth/setUserConnect', con)
  },
  beforeDestroy () {
    this.$store.dispatch('virtualOffice/sendVirtualOfficeSV', '[DISCONNECT]')
  },
  destroyed () {
    setTimeout(() => {
      this.$store.dispatch('virtualOffice/disconnectVirtualOfficeSV')
    }, 500)
  },
  methods: {
    allClose () {
      this.ListDirectFlg = false
      this.ListRoboCreateFlg = false
      this.ListRoboFlg = false
      this.ListSettingFlg = false
      this.ListOperationFlg = false
      this.ListVideoInteviewFlg = false
      this.ListUserInfoFlg = false
      this.reportFlg = false
    },
    showRoboCreate (flag) {
      this.allClose()
      this.isShowRoboCreate = flag
    },
    showRoboCreateRequest (flag) {
      this.allClose()
      this.isShowRoboCreateRequest = flag
    },
    handleClick_changeLanguage (lang) {
      this.$i18n.locale = lang
    },
    logout () {
      this.$store.dispatch('auth/logout')
        .then(() => {
          // ログアウト後はAPIが叩けなくなるため、ログアウト前に離脱ログを送信する
          const p1 = this.sendControlLogRelatedUsage('HRモンスター離脱', 'HRモンスターの管理ページを閉じた')
          const p2 = this.sendControlLog('ログアウト', '画面左側メニューのログアウトボタンをクリックした。')
          return Promise.all([p1, p2])
        })
        .then(() => {
          this.logoutBar()
        })
    },
    logoutBar () {
      this.$buefy.snackbar.open({
        message: 'ログアウトしました。',
        type: 'is-primary',
        position: 'is-top'
      })
      document.location.href = '/login'
    },
    setRHModal () {
      this.$store.dispatch('auth/setRHModal')
    },
    getCompanyList () {
      this.$store.dispatch('auth/getCompanyList')
    },
    updateUserCompany (id) {
      this.$store.dispatch('auth/updateUserCompany', {companyID: id})
    },
    releaseMarkdownModal () {
      this.allClose()
      this.isReleaseMarkdown = true
    },
    viewMarkdownModal () {
      this.allClose()
      this.isViewMarkdown = true
      this.localData = []
      this.storageData = JSON.parse(localStorage.getItem('IS_RELEASE_READ') || null)
      if (this.storageData == null) {
        this.storageData = {}
      }
      for (var i = 0; i < Object.keys(this.storageData).length; i++) {
        this.localData.push(this.storageData[i])
      }
    },
    getTimes (time) {
      var ja_time = new Date(time.replace(/-/g, '/').substring(0, 17) + time.substring(25, 29)).toString()
      var new_time = ja_time
        .replace(/Jan/g, '01')
        .replace(/Feb/g, '02')
        .replace(/Mar/g, '03')
        .replace(/Apr/g, '04')
        .replace(/May/g, '05')
        .replace(/Jun/g, '06')
        .replace(/Jul/g, '07')
        .replace(/Aug/g, '08')
        .replace(/Sep/g, '09')
        .replace(/Oct/g, '10')
        .replace(/Nov/g, '11')
        .replace(/Dec/g, '12')
      var get_year = new_time.substring(10,14)
      var get_month = new_time.substring(4,6)
      var get_day = new_time.substring(7,9)
      var get_time = new_time.substring(15,20)
      var dis_time = get_year + '-' + get_month + '-' + get_day + ' ' + get_time
      return dis_time
    },
    getSort (time) {
      var ja_time = new Date(time.replace(/-/g, '/').substring(0, 17) + time.substring(25, 29)).toString()
      var new_time = ja_time
        .replace(/Jan/g, '01')
        .replace(/Feb/g, '02')
        .replace(/Mar/g, '03')
        .replace(/Apr/g, '04')
        .replace(/May/g, '05')
        .replace(/Jun/g, '06')
        .replace(/Jul/g, '07')
        .replace(/Aug/g, '08')
        .replace(/Sep/g, '09')
        .replace(/Oct/g, '10')
        .replace(/Nov/g, '11')
        .replace(/Dec/g, '12')
      var get_year = new_time.substring(10,14)
      var get_month = new_time.substring(4,6)
      var get_day = new_time.substring(7,9)
      var get_hour = new_time.substring(15,17)
      var get_minute = new_time.substring(18,20)
      var dis_time = get_year + get_month + get_day + get_hour + get_minute
      return Number(dis_time)
    },
    sendMessage () {
      var readID = localStorage.getItem('IS_RELEASE_READ')
      var dataDate = []
      var array=[]
      var result=[]
      var releaseID = 1000000000000
      var contentsID = ""
      for (var i in this.localData) {
        dataDate.push(this.localData[i].slice(-12))
      }
      result = dataDate.filter(function (item) {
        return item.indexOf("undefined")== -1 && item.indexOf("000000000000")== -1
      })
      var sortDataDate = result.sort().pop()

      if (readID != null) {
        for (let i in this.releaseTexts) {
          if (this.getSort(this.releaseTexts[i].updated_at) >= sortDataDate) {
            array.push(this.getSort(this.releaseTexts[i].updated_at))
          }
        }
        array.sort(function (a, b) {
          if(a < b) return -1;
          if(a > b) return 1;
          return 0;
        })
        return array[0]
      } else {
        for (let i in this.releaseTexts) {
          if (this.getSort(this.releaseTexts[i].updated_at) < releaseID) {
            releaseID = this.getSort(this.releaseTexts[i].updated_at)
            contentsID = this.releaseTexts[i].contents_id
          }
        }
        this.messageData[Object.keys(this.storageData).length] = contentsID + "/" + releaseID
        return releaseID
      }
    },
    sendID () {
      var sendID = ""
      for (var i in this.releaseTexts) {
        if (this.getSort(this.releaseTexts[i].updated_at) == this.sendMessage()) {
          sendID = this.releaseTexts[i].contents_id
        }
      }
      return sendID
    },
    sendValue () {
      var sendValue = ""
      for (var i in this.releaseTexts) {
        if (this.getSort(this.releaseTexts[i].updated_at) == this.sendMessage()) {
          sendValue = this.releaseTexts[i].contents
        }
      }
      return sendValue
    },
    sendDate () {
      var sendDate = ""
      for (var i in this.releaseTexts) {
        if (this.getSort(this.releaseTexts[i].updated_at) == this.sendMessage()) {
          sendDate = this.getTimes(this.releaseTexts[i].updated_at)
        }
      }
      return sendDate
    },
    sendTitle () {
      var sendTitle = ""
      for (var i in this.releaseTexts) {
        if (this.getSort(this.releaseTexts[i].updated_at) == this.sendMessage()) {
          sendTitle = this.releaseTexts[i].title
        }
      }
      return sendTitle
    },
    getScoutSeeker () {
      return
      // this.$store.dispatch('directtalk/getSeeker', 'scout')
    },
    contentsMethod () {
      this.localData=[]
      this.storageData = JSON.parse(localStorage.getItem('IS_RELEASE_READ') || null)
      if (this.storageData == null) {
        this.storageData = {}
      }
      for (var i = 0; i < Object.keys(this.storageData).length; i++) {
        this.localData.push(this.storageData[i])
      }
    },
    getAliveDay () {
      return 10 + '日'
    },
    alertResult (alertResultData) {
      if (alertResultData) {
        if (alertResultData.alertKeyFunction === 'client-nav') {
          if (alertResultData.alertKeyWord === 'reload-alert') {
            this.isAlertDialogOpen = false
            // リロードして応募者管理画面へ
            location.href = '/client/manage'
          }
        }
      }
    },
    focusIn () {
      // 現在の会社IDを取得
      const afterCompany = localStorage.getItem('_user_c')
      if (this.user.companyID !== afterCompany) {
        // 別のタブかウィンドウで会社が変更されていたらアラートを出してリロードする
        this.alertData = createAlertData(
          '会社変更リロード',
          '他のタブかウィンドウで会社が変更されました。\nリロードします。',
          ALERT_DEF.MESSAGE_INFO,
          ALERT_DEF.DIALOG_ALERT,
          'client-nav',
          'reload-alert'
        )
        this.isAlertDialogOpen = true
      }
    },
    mouseleaveReset () {
      this.ListDirectFlg = false
      this.ListRoboCreateFlg = false
      this.ListRoboFlg = false
      this.ListSettingFlg = false
      this.ListOperationFlg = false
      this.ListVideoInteviewFlg = false
      this.ListUserInfoFlg = false
      this.reportFlg = false
    },
    mouseoverDirect (e) {
      this.ListDirectFlg = true
    },
    mouseleaveDirect (e) {
      if (e.clientX > 210) this.ListDirectFlg = false
    },
    mouseoverListRoboCreate (e) {
      this.mouseleaveReset()
      this.ListRoboCreateFlg = true
    },
    mouseleaveListRoboCreate (e) {
      if (e.clientX > 210) this.ListRoboCreateFlg = false
    },
    mouseoverListRobo (e) {
      this.mouseleaveReset()
      this.ListRoboFlg = true
    },
    mouseleaveListRobo (e) {
      if (e.clientX > 210) this.ListRoboFlg = false
    },
    mouseoverSetting (e) {
      this.mouseleaveReset()
      this.ListSettingFlg = true
    },
    mouseleaveSetting (e) {
      if (e.clientX > 210) this.ListSettingFlg = false
    },
    mouseoverOperation (e) {
      this.mouseleaveReset()
      this.ListOperationFlg = true
    },
    mouseleaveOperation (e) {
      if (e.clientX > 210) this.ListOperationFlg = false
    },
    mouseoverVideoInteview (e) {
      this.ListVideoInteviewFlg = true
    },
    mouseleaveVideoInteview (e) {
      if (e.clientX > 210) this.ListVideoInteviewFlg = false
    },
    mouseoverReport (e) {
      this.mouseleaveReset()
      this.reportFlg = true
    },
    mouseleaveReport (e) {
      if (e.clientX > 210) this.reportFlg = false
    },
    moveToScenarioTop () {
      let chatbot = this.chatbots.find((bot)=>!bot.is_archive && isRoboEditPermission(bot, this.user) === true && bot.is_template === false)
      if (chatbot) {
        this.$store.dispatch('chatbot/getScenario', { companyid: this.user.companyID, scenarioName: chatbot.scenario_name })
        this.$store.dispatch('chatbot/selectChatbot', chatbot)
        this.$router.push('/client/chatbot?view=scenario&scenario=' + chatbot.scenario_name)
      } else {
        alert('編集権限のあるロボがいないため、ロボ編集画面に遷移できません。')
      }
    },
    isMenuMinimumSize () {
      this.$store.dispatch('setting/changeMenuMiniSize')
    },
    mouseoverUserInfo (e) {
      this.ListUserInfoFlg = true
    },
    mouseleaveUserInfo (e) {
      if (e.clientX > 210) this.ListUserInfoFlg = false
    },
  },
  beforeDestroy () {
    window.removeEventListener('focus', this.focusIn)
  },
  created () {
    this.$store.dispatch('auth/getcreateManage')
    this.$store.dispatch('sitemap/getSitemapRootList')
    this.$store.dispatch('auth/getScout')
    this.$store.dispatch('auth/getUsers')
    this.$store.dispatch('mediapool/getAllImages')
    this.$store.dispatch('mediapool/getAllVideos')
    this.$store.dispatch('auth/getDepartment', null)
    this.$store.dispatch('auth/getPosition', null)
    this.$store.dispatch('chatbot/getChatBotTag', null)
    this.$store.dispatch('chatbot/getChatBots')
    this.$store.dispatch('chatbot/getRoboPartsSet', this.user.companyID)
    this.$store.dispatch('chatbot/getStory')
    this.$store.dispatch('virtualOffice/getVirtualOffice', null)
    var con = {
      'is_connect': true
    }
    this.$store.dispatch('auth/setUserConnect', con)
    this.$store.dispatch('auth/getStoreCateogry')
    this.$store.dispatch('chatbot/getChatBotStoreItem')
    this.$store.dispatch('auth/getGoogleDriveAuthStatus')
    this.$store.dispatch('auth/getUsersStatusAPI')
    const uri = process.env.WS_ENDPOINT + 'list/' + this.user.companyID + '/' + this.user.email
    this.$store.dispatch('directtalk/connectList', uri)
    this.$store.dispatch('auth/payperuseInfo')
    // 無料トライアル過ぎている場合
    let deltaDay = (new Date() - new Date(this.user.createdAt)) / 86400000
    if (deltaDay > 14 && this.user.billing === 0) {
      this.isShowBilling = true
    }
    this.getCompanyList()
  },
}
</script>

<style lang="scss" scoped>
.custom-menu {
  background: #AA0066;
  min-width: 210px;
  max-width: 210px;
  height: calc(100vh - 1px);
  margin: 0 !important;
  display: flex;
  text-align: left;
  z-index: 100000;
}
.custom-menu-min {
  background: #AA0066;
  min-width: 50px;
  max-width: 50px;
  height: calc(100vh - 1px);
  margin: 0 !important;
  display: flex;
  text-align: left;
  z-index: 100000;
}
.menu-list {
  width: 200px;
  font-size: smaller;
}
.click-menu {
  background-color:rgba(240, 200, 200, 0.8) !important;
}
.hover-menu {
  color: white;
  transition: 0.5s;
  display: flex;
  align-items: center;
}
.hover-menu:hover {
  color: white;
  background-color:rgba(240, 200, 200, 0.8) !important;
}
.startup {
  cursor: not-allowed;
  color: rgba(240, 200, 200, 0.8);
}
.startup:hover {
  cursor: not-allowed;
  color: rgba(240, 200, 200, 0.8);
}
.list-direct {
  position: relative;
}
.list-robo-employment {
  position: relative;
}
.list-robo {
  position: relative;
}
.list-setting {
  position: relative;
}
.list-operation {
  position: relative;
}
.list-info {
  position: relative;
}
.list-report {
  position: relative;
}
.dropdown-list {
  width: 200px;
  position: fixed;
  left: 210px;
  line-height:30px;
  background-color: #FEFEFE;
  border: 0.7px solid rgba(150, 140, 140, 0.8);
  box-shadow: 3px 3px 10px rgba(0,0,0,0.2);
  border-left: none;
  z-index: 10;
  a,.link {
    padding: 8px;
    border-radius: 2px;
    border-bottom: solid 0.7px rgba(150, 140, 140, 0.8);
  }
  a:hover,.link:hover {
    background-color:rgba(240, 200, 200, 0.8);
    color: #fff;
    cursor: pointer;
  }
  .icon {
    margin-right: 4px;
  }
}
.dropdown-list-mini {
  width: 200px;
  position: fixed;
  left: 50px;
  line-height:30px;
  background-color: #FEFEFE;
  border: 0.7px solid rgba(150, 140, 140, 0.8);
  box-shadow: 3px 3px 10px rgba(0,0,0,0.2);
  border-left: none;
  z-index: 10;
  a,.link {
    padding: 8px;
    border-radius: 2px;
    border-bottom: solid 0.7px rgba(150, 140, 140, 0.8);
  }
  a:hover,.link:hover {
    background-color:rgba(240, 200, 200, 0.8);
    color: #fff;
    cursor: pointer;
  }
  .icon {
    margin-right: 4px;
  }
}
.menu-list li ul {
    border-left: none;
    margin: 0;
    padding: 0;
}
.click-submenu {
  color: #fff;
  background: rgba(150, 140, 140, 0.8);
}
.account-img {
  width:  auto;
  height: 25px;
  border-radius: 50%;
  object-fit: cover;
  background: #fefefe;
  border: solid 2px #C82E42;
}
.no-viewing-permission-applicant {
  padding: 0.5em 0.75em;
}
</style>



// WEBPACK FOOTER //
// src/views/Client/ClientMainMenu.vue